import { ref } from 'vue'

const eventBus = ref(new Map())

export function useEventBus() {
  return {
    on(event: any, callback: any) {
      if (!eventBus.value.has(event)) {
        eventBus.value.set(event, [])
      }
      eventBus.value.get(event).push(callback)
    },
    emit(event: any, data?: any) {
      if (eventBus.value.has(event)) {
        eventBus.value.get(event).forEach((callback: (arg0: any) => any) => callback(data))
      }
    },
  }
}
